<template>
  <div id="privacy">
    <p>Below is a privacy policy designed as a CYA (for us), but here's the TLDR: We won't share or sell your information with anyone, and we only collect at most an username, password, email, and an ID for any game service you got this game from (Steam/Google/etc), as well as "Play Data" which gives us information about which actions are performed within the levels. You have the option to not provide any of the mentioned information and it is only required if you wish to share your custom created levels, or to interact with the levels others have created (rating / best time / etc).</p>
    
    <h1>Privacy Policy</h1>
    <p><span class="red-menace">RED MENACE</span> built <span class="super-twins">SUPER</span> <span class="marxist">MARXIST</span> <span class="super-twins">TWINS</span> as a Commercial game. This SERVICE is provided by <span class="red-menace">RED MENACE</span> and is intended for use as is.

This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.

If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.

The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at redmenacegames.com unless otherwise defined in this Privacy Policy.</p>

    <h2>Information Collection and Use</h2>
    <p>For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information. The information that we request will be retained by us and used as described in this privacy policy.

The game does use third party services that may collect information used to identify you.

Link to privacy policy of third party service providers used by the game

    Google Play Services
    Steam
    Unity</p>

    <h2>Log Data</h2>
    <p>We want to inform you that whenever you use our Service, in a case of an error in the game we collect data and information (through third party products) on your device called Log Data. This Log Data may include information such as your device Internet Protocol ("IP") address, device name, operating system version, the configuration of the game when utilizing our Service, the time and date of your use of the Service, and other statistics.</p>

    <h2>Cookies</h2>
    <p>Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.

This Service does not use these "cookies" explicitly. However, the game may use third party code and libraries that use "cookies" to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.</p>

    <h2>Service Providers</h2>
    <p>We may employ third-party companies and individuals due to the following reasons:

    To facilitate our Service;
    To provide the Service on our behalf;
    To perform Service-related services; or
    To assist us in analyzing how our Service is used.

We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</p>

    <h2>Security</h2>
    <p>We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p>

    <h2>Links to Other Sites</h2>
    <p>This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

    <h2>Children's Privacy</h2>
    <p>These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.</p>

    <h2>Changes to This Privacy Policy</h2>
    <p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.</p>

    <h2>Contact Us</h2>
    <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at <a href="mailto:privacy@redmenacegames.com">privacy@redmenacegames.com</a> or on our <a href="https://discord.gg/D6BuHNhXHJ" target="_blank">Discord server</a>.</p>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#privacy {
  width: 50%;
  margin: auto;
  font-size: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

a {
  color: var(--text-color);
  vertical-align: middle;
  cursor: pointer;
  padding: 0 2px;
  color: var(--text-color);
  /* background-color: var(--primary-color); */
  border-radius: 5px;
}

a:hover {
  background-color: var(--secondary-color);
}
</style>